import { useEffect, useRef, useState } from "react";

// Signature soft-follow cursor. Desktop only (opt out on touch / small screens).
export default function CustomCursor() {
    const dotRef = useRef(null);
    const ringRef = useRef(null);
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const supportsHover =
            window.matchMedia?.("(hover: hover) and (pointer: fine)").matches;
        if (!supportsHover) return;
        setEnabled(true);

        let mouseX = window.innerWidth / 2;
        let mouseY = window.innerHeight / 2;
        let ringX = mouseX;
        let ringY = mouseY;
        let raf;

        const onMove = (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
            if (dotRef.current) {
                dotRef.current.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
            }
        };

        const tick = () => {
            // Smooth easing for the ring
            ringX += (mouseX - ringX) * 0.16;
            ringY += (mouseY - ringY) * 0.16;
            if (ringRef.current) {
                ringRef.current.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
            }
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);

        const hoverSel =
            "a, button, [role='button'], [data-cursor='hover'], input, textarea, select, label";

        const onOver = (e) => {
            if (e.target.closest?.(hoverSel)) {
                ringRef.current?.classList.add("cursor-active");
                dotRef.current?.classList.add("cursor-dot-hidden");
            }
        };
        const onOut = (e) => {
            if (e.target.closest?.(hoverSel)) {
                ringRef.current?.classList.remove("cursor-active");
                dotRef.current?.classList.remove("cursor-dot-hidden");
            }
        };

        document.addEventListener("mousemove", onMove, { passive: true });
        document.addEventListener("mouseover", onOver);
        document.addEventListener("mouseout", onOut);
        document.body.classList.add("has-custom-cursor");

        return () => {
            cancelAnimationFrame(raf);
            document.removeEventListener("mousemove", onMove);
            document.removeEventListener("mouseover", onOver);
            document.removeEventListener("mouseout", onOut);
            document.body.classList.remove("has-custom-cursor");
        };
    }, []);

    if (!enabled) return null;

    return (
        <>
            <div
                ref={ringRef}
                aria-hidden
                className="cursor-ring fixed top-0 left-0 z-[90] pointer-events-none w-8 h-8 rounded-full border border-[#0D1B1A]/40 mix-blend-difference will-change-transform transition-[width,height,border-color,background-color] duration-300 ease-out"
                style={{ transform: "translate(-100px, -100px)" }}
            />
            <div
                ref={dotRef}
                aria-hidden
                className="cursor-dot fixed top-0 left-0 z-[90] pointer-events-none w-1 h-1 rounded-full bg-[#D4944C] will-change-transform"
                style={{ transform: "translate(-100px, -100px)" }}
            />
        </>
    );
}
